module.exports = __webpack_public_path__ + "static/media/solutions-mobile_cn.03e71236.jpg";